/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CancelPricingAgreementRequest
 */
export interface CancelPricingAgreementRequest {
  /**
   *
   * @type {string}
   * @memberof CancelPricingAgreementRequest
   */
  agreementId: string;
  /**
   *
   * @type {string}
   * @memberof CancelPricingAgreementRequest
   */
  cancellationReason?: string | null;
}

/**
 * Check if a given object implements the CancelPricingAgreementRequest interface.
 */
export function instanceOfCancelPricingAgreementRequest(
  value: object,
): value is CancelPricingAgreementRequest {
  if (!("agreementId" in value) || value["agreementId"] === undefined)
    return false;
  return true;
}

export function CancelPricingAgreementRequestFromJSON(
  json: any,
): CancelPricingAgreementRequest {
  return CancelPricingAgreementRequestFromJSONTyped(json, false);
}

export function CancelPricingAgreementRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CancelPricingAgreementRequest {
  if (json == null) {
    return json;
  }
  return {
    agreementId: json["agreementId"],
    cancellationReason:
      json["cancellationReason"] == null
        ? undefined
        : json["cancellationReason"],
  };
}

export function CancelPricingAgreementRequestToJSON(
  json: any,
): CancelPricingAgreementRequest {
  return CancelPricingAgreementRequestToJSONTyped(json, false);
}

export function CancelPricingAgreementRequestToJSONTyped(
  value?: CancelPricingAgreementRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agreementId: value["agreementId"],
    cancellationReason: value["cancellationReason"],
  };
}
